export default __webpack_public_path__ + "static/media/ETH.e2d860f4.svg";